import type { PageTemplateModule } from './types'

/**
 * Default template for standard pages
 * No additional data fetching beyond base page query
 */
export const defaultTemplate: PageTemplateModule = {
  /**
   * Default template doesn't need additional data
   * All data comes from the base page query
   */
  async fetchData() {
    return {}
  },

  /**
   * Component is handled by the existing DynamicPage component
   * This template uses the default page rendering logic
   */
  component: () => null, // Will be replaced by the actual DynamicPage component
}
